
;
                (function(){
                    const Func = (function() {
                        const e=this.$el;if(!e)return;let t=e.querySelector(".ecom-masonry-layout");if(!t)return;t.addEventListener("itemChange",function(){setTimeout(function(){t.masonry.layout()},500)});var i=t.getAttribute("data-ecom-packery-params")||"{}";let n=Object.assign({itemSelector:".ecom-masonry-layout__item",layoutMode:"masonry",percentPosition:!0,resize:!0},JSON.parse(i));var a=new window.EComPackery(t,n);t.masonry=a,t.querySelectorAll("img").forEach(function(o){o.addEventListener("load",function(){a.layout()})})
                    
                    });
                    const settings = {};
                    const ID = 'ecom-7zfufhyhhvp';
                    document.querySelectorAll('.ecom-7zfufhyhhvp').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            